var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "gps-map" } },
    [
      _c("b-loading", {
        attrs: { active: _vm.isLoading, "is-full-page": false },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          [
            _vm.isFetchingMarkerData
              ? _c("b-icon", {
                  attrs: {
                    type: "is-info",
                    size: "is-large",
                    icon: "spinner",
                    "custom-class": "fa-spin",
                  },
                })
              : _vm._e(),
            _vm._v(" " + _vm._s(_vm.markerData) + " "),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            !_vm.isLoading
              ? _c(
                  "VueLeafletMap",
                  {
                    attrs: {
                      markers: _vm.filteredMarkers,
                      name: "leaflet",
                      "no-coords": _vm.noCoords,
                    },
                  },
                  [
                    _c("map-filter", {
                      attrs: { markers: _vm.markers },
                      on: {
                        "filter-changed": (markers) =>
                          (_vm.filteredMarkers = markers),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }